<li *ngIf="bot">
  <!-- <a [href]="portalSettings.url + '/bot/' + bot.bot_id"> -->
    <a [routerLink]="['/bot', bot.bot_id, 'dashboard']" [matMenuTriggerFor]="botMenu">
      <img [src]="bot.image" alt="" class="nav-menu__image" />
      {{ bot.name }}
      <i class="material-icons nav-menu__dropdown">arrow_drop_down</i>
    </a>
    <mat-menu #botMenu="matMenu" [class]="'brn-menu'">
      <a mat-menu-item [routerLink]="['/dashboard']">
        Dashboard
      </a>
      <a mat-menu-item [routerLink]="['/portals']">
        Portals
      </a>
    </mat-menu>
</li>
